import { appLocalStorage, appSessionStorage } from '../utils/storage';
import { routePath } from '../appLinks/links';

export const ONBOARDING_KEY = 'guest-onboarding:v1';
const VISIT_KEY = 'guest-onboarding:skip-visit';
export const STEP_COUNT = 5;
let memory = { step: 0, completed: false };

export function readProgress() {
  try {
    const value = JSON.parse(appLocalStorage.getItem(ONBOARDING_KEY));
    if (value && Number.isInteger(value.step) && value.step >= 0 && value.step < STEP_COUNT
      && typeof value.completed === 'boolean') memory = { step: value.step, completed: value.completed };
  } catch { /* Private browsing can disable persistence; the lesson still works. */ }
  return memory;
}

export function saveProgress(step, completed = false) {
  if (!Number.isInteger(step) || step < 0 || step >= STEP_COUNT) return;
  memory = { step, completed: completed || readProgress().completed };
  try { appLocalStorage.setItem(ONBOARDING_KEY, JSON.stringify(memory)); } catch { /* Memory fallback. */ }
}

export function skipVisit() {
  try { appSessionStorage.setItem(VISIT_KEY, '1'); } catch { /* Provider also keeps this in memory. */ }
}

export function isPlainHome(location) {
  return routePath(location.pathname) === '/' && !location.search && !location.hash;
}

export function eligibleEntry(location, referrer, authenticated = false) {
  if (authenticated || !isPlainHome(location) || location.state) return false;
  try {
    if (appSessionStorage.getItem(VISIT_KEY)) return false;
    // Unknown query/hash, external referrers and explicit native links take
    // priority over teaching. A browser can omit referrer entirely.
    if (referrer && new URL(referrer).origin !== window.location.origin) return false;
  } catch { return false; }
  return !readProgress().completed;
}
